import React, { Component } from "react";
import { Divider, Select } from "antd";
import styles from "./pushInfo.module.less";
import classnames from 'classnames';
import { DarkModal } from "@/components/Modal";
import darkControl from "@/components/Modal/darkControl.module.less";
import * as DICT from "@/utils/dict"
import AlarmStatus from "../../../modal/handleAlarm/AlarmStatus"
import Tag from "@/components/Tag";
import http from "@/http"
const HttpPushMessage = http.tokiot.sys.pushMessage;
const HttpSystemNotice = http.tokiot.sys.systemNotice;

export default class PushInfo extends Component {
    componentDidMount() {
    }

    render() {
        const { pushInfo, className } = this.props;
        if (!(pushInfo && pushInfo.id && pushInfo.id.length > 0)) return ``;
        let pushType = [];
        if (pushInfo.pushWayApp) pushType.push(<Tag color={`gray6`}>APP推送</Tag>);
        if (pushInfo.pushWaySms) pushType.push(<Tag color={`gray6`}>短信推送</Tag>);
        if (pushInfo.pushWayTel) pushType.push(<Tag color={`gray6`}>电话推送</Tag>);
        if (pushInfo.pushWayWeb) pushType.push(<Tag color={`gray6`}>网页推送</Tag>);
        if (pushInfo.pushWayWechat) pushType.push(<Tag color={`gray6`}>微信推送</Tag>);
        return (
            <div className={classnames(styles.mainDiv, className)}>
                <div className={styles.row}>
                    <span className={styles.text}>{DICT.getValue('PUSH_MESSAGE_BIZ_TYPE', pushInfo.bizType)}:</span>
                    <span className={styles.text}>{pushInfo.username}</span>
                    <span className={styles.text}>{pushInfo.createdTime}</span>
                </div>
                {pushInfo.readTime && pushInfo.readTime.length > 0 ?
                    <div className={styles.row}>
                        <span className={styles.text}>{`${DICT.getValue('PUSH_MESSAGE_READ_TYPE', pushInfo.readType)}读取:`}</span>
                        <span className={styles.text}>{pushInfo.readTime}</span>
                    </div>
                    : ``}
                <div className={styles.row}>
                    {pushType}
                </div>
            </div>
        );
    }
}

